export enum URIPrefix {
  AGE = 'age',
  CITY = 'cty',
  GENDER = 'gdr',
  INSURANCE = 'ins',
  MODALITY = 'mod',
  SESSION_TYPE = 'sess',
  SPECIALTY = 'spc',
  STATE = 'sta',
  TREATMENT_PREFERENCE = 'tap'
}
